import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomMultiSelect,
  InputText,
  Periodo,
  SectionTitle,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import XmlDeliveryHttp from '../../../../../services/api/https/deliveries/xml-delivery.http'
import { withRouter } from 'react-router-dom'
import {
  formatIsoDateToLocale,
  getPeriodoMesAtual,
} from '../../../../../services/util/date.service'
import { getCicloInfo } from '../../../../../services/api/https/deliveries/importation.http'
import CardsResultadoImportacao from '../../ImportacaoCicloEntrega/CardsResultadoImportacao'
import TabsClientesEhProdutosNaoCadastrados from '../../ImportacaoCicloEntrega/TabsClientesEhProdutosNaoCadastrados'
import { urlDownloadXmls } from '../../../../../services/api/routes/deliveries.routes'

const { dataInicial, dataFinal } = getPeriodoMesAtual()
const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando...',
  IMPORTING: 'Importando XMLs',
  SUCCESS: 'XMLs importados com sucesso',
}
const ShowMode = {
  MESSAGE: 'MESSAGE',
  CARDS: 'CARDS',
  TABS: 'TABS',
}
const INITIAL_STATE = {
  xmls: [],
  xmlsFiltered: [],
  selecionarTodos: false,
  pInicial: dataInicial,
  pFinal: dataFinal,
  loadingMessage: LOAD_MESSAGE.NONE,
  ufs: [],
  selectedUfs: [],
  citiesOptions: [],
  selectedCities: [],
  bairrosOptions: [],
  selectedBairros: [],
  infoComplementarOptions: [],
  selectedInfoComplementar: [],
  beepNf: '',
  result: {
    qteDeliveries: '',
    qteIdentifiers: '',
    qteSkus: '',
    weight: '',
  },
  showMode: ShowMode.MESSAGE,
  produtosSemCadastros: [],
  clientesSemCadastros: [],
  produtosComInconsistencia: [],
}
function AssociarXmls({ ciclo, dispatch, selectedTp }) {
  const [globalFilter, setGlobalFilter] = useState('')
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (state.selectedUfs.length) {
      const selectedUfs = state.selectedUfs.map(uf => uf.id)
      const cities = Array.from(
        new Set(state.xmls.filter(xml => selectedUfs.includes(xml.uf)).map(xml => xml.city_name)),
      ).map(city => ({ id: city, name: city }))
      setState(prevState => ({
        ...prevState,
        citiesOptions: cities,
        xmlsFiltered: prevState.xmls.filter(xml => selectedUfs.includes(xml.uf)),
      }))
      return
    }

    setState(prevState => ({
      ...prevState,
      citiesOptions: [],
      bairrosOptions: [],
      selectedCities: [],
      selectedBairros: [],
      xmlsFiltered: state.xmls,
    }))
  }, [state.selectedUfs])

  useEffect(() => {
    if (state.selectedCities.length) {
      const selectedCities = state.selectedCities.map(city => city.id)
      const bairros = Array.from(
        new Set(
          state.xmls.filter(xml => selectedCities.includes(xml.city_name)).map(xml => xml.bairro),
        ),
      ).map(bairro => ({ id: bairro, name: bairro }))

      setState(prevState => ({
        ...prevState,
        bairrosOptions: bairros,
        xmlsFiltered: prevState.xmls.filter(xml => selectedCities.includes(xml.city_name)),
      }))
      return
    }
    const selectedUfs = state.selectedUfs.map(uf => uf.id)
    setState(prevState => ({
      ...prevState,
      bairrosOptions: [],
      selectedBairros: [],
      xmlsFiltered: selectedUfs.length
        ? state.xmls.filter(xml => selectedUfs.includes(xml.uf))
        : state.xmls,
    }))
  }, [state.selectedCities])

  useEffect(() => {
    if (state.selectedBairros.length) {
      const selectedBairros = state.selectedBairros.map(bairro => bairro.id)
      setState(prevState => ({
        ...prevState,
        xmlsFiltered: prevState.xmls.filter(xml => selectedBairros.includes(xml.bairro)),
      }))
      return
    }
    const selectedUfs = state.selectedUfs.map(uf => uf.id)
    const selectedCities = state.selectedCities.map(city => city.id)
    setState(prevState => ({
      ...prevState,
      xmlsFiltered: selectedCities.length
        ? prevState.xmls.filter(xml => selectedCities.includes(xml.city_name))
        : selectedUfs.length
          ? prevState.xmls.filter(xml => selectedUfs.includes(xml.uf))
          : prevState.xmls,
    }))
  }, [state.selectedBairros])

  useEffect(() => {
    const selectedInfo = state.selectedInfoComplementar.map(i => i.id)

    const xmlsComSelecao = state.xmls.map(xml => ({
      ...xml,
      selected: selectedInfo.length ? selectedInfo.includes(xml.info_complementar) : false,
    }))

    const xmlsFiltrados = selectedInfo.length
      ? xmlsComSelecao.filter(xml => selectedInfo.includes(xml.info_complementar))
      : (() => {
          const bairros = state.selectedBairros.map(b => b.id)
          const cities = state.selectedCities.map(c => c.id)
          const ufs = state.selectedUfs.map(u => u.id)

          return bairros.length
            ? xmlsComSelecao.filter(xml => bairros.includes(xml.bairro))
            : cities.length
              ? xmlsComSelecao.filter(xml => cities.includes(xml.city_name))
              : ufs.length
                ? xmlsComSelecao.filter(xml => ufs.includes(xml.uf))
                : xmlsComSelecao
        })()

    setState(prev => ({
      ...prev,
      xmls: xmlsComSelecao,
      xmlsFiltered: xmlsFiltrados,
      selecionarTodos: !!selectedInfo.length,
    }))
  }, [state.selectedInfoComplementar])

  useEffect(() => {
    const fetchCicloInfo = async () => {
      const { qteDeliveries, qteIdentifiers, qteSkus, weight } = await getCicloInfo(ciclo.id)
      if (qteDeliveries) {
        setState(prevState => ({
          ...prevState,
          result: { qteDeliveries, qteIdentifiers, qteSkus, weight },
          loadingMessage: LOAD_MESSAGE.NONE,
          showMode: ShowMode.CARDS,
        }))
        return
      }
      if (!selectedTp) {
        dispatch(showMessageBox(null, 'Selecione um operador logístico'))
        return
      }
      fetchEntregas(state.pInicial, state.pFinal)
    }
    fetchCicloInfo()
  }, [ciclo, selectedTp])

  // Helpers
  const fetchEntregas = async (pInicial, pFinal) => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOADING }))

    XmlDeliveryHttp.getXmlDeliveries(selectedTp, ciclo.id, pInicial, pFinal)
      .then(xmls => {
        const ufs = Array.from(new Set(xmls.map(xml => xml.uf))).map(uf => ({ id: uf, name: uf }))
        const infoComplementarOptions = Array.from(
          new Set(xmls.map(xml => xml.info_complementar).filter(Boolean)), // remove null/undefined
        ).map(ic => ({ id: ic, name: ic }))

        setState(prevState => ({
          ...prevState,
          xmls,
          xmlsFiltered: xmls,
          ufs,
          infoComplementarOptions,
          beepNf: '',
        }))
      })
      .catch(e => {
        dispatch(showMessageBox(null, errorHandler(e)))
      })
      .finally(() => setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.NONE })))
  }

  const waitXmlAssociationJob = async jobId => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    while (true) {
      await sleep(2000)
      const job = await XmlDeliveryHttp.getXmlAssociationJob(jobId)
      if (job.status === 'completed') return job.result
      if (job.status === 'failed' || job.status === 'compensation_failed') {
        throw job.error || new Error('Erro ao associar XMLs')
      }
    }
  }

  // Events
  const onAssociarXmls = async () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.IMPORTING }))

    try {
      const selectedXmls = state.xmlsFiltered.filter(xml => xml.selected)
      if (!selectedXmls.length) throw new Error('Nenhum XML selecionado')
      const xml_ids = selectedXmls.map(xml => xml.id)
      const association = await XmlDeliveryHttp.associateXmlDeliveries(
        ciclo.id,
        selectedTp,
        xml_ids,
      )
      const result =
        association.status === 'completed'
          ? association.result
          : await waitXmlAssociationJob(association.job_id)
      const { qteDeliveries, qteIdentifiers, qteSkus, weight } = result

      dispatch(showMessageBox('XML importado com sucesso', null))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.SUCCESS,
        xmlsFiltered: prevState.xmlsFiltered.filter(xml => !xml.selected),
        result: { qteDeliveries, qteIdentifiers, qteSkus, weight },
        showMode: ShowMode.CARDS,
      }))
    } catch (error) {
      const {
        message,
        clientsNotSaved = [],
        productsNotSaved = [],
        productsWithInconsistency = [],
      } = error
      if (message) {
        dispatch(showMessageBox(null, message))
        const hasImportPendencies =
          clientsNotSaved.length > 0 ||
          productsNotSaved.length > 0 ||
          productsWithInconsistency.length > 0

        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          showMode: hasImportPendencies ? ShowMode.TABS : ShowMode.MESSAGE,
          produtosSemCadastros: productsNotSaved,
          clientesSemCadastros: clientsNotSaved,
          produtosComInconsistencia: productsWithInconsistency,
        }))
      } else {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          showMode: ShowMode.MESSAGE,
        }))
        dispatch(showMessageBox(null, errorHandler(error)))
      }
      dispatch(hideLoadingBox())
    }
  }

  const onCheckBoxClicked = (item, value) => {
    const xml = state.xmlsFiltered.find(i => i.id === item.id)
    xml.selected = value
    setState(prevState => ({
      ...prevState,
      xmlsFiltered: [...state.xmlsFiltered],
    }))
  }

  const onBeepNfEnter = () => {
    const chave = (state.beepNf || '').trim()

    if (!chave) {
      setState(prevState => ({ ...prevState, beepNf: '' }))
      return
    }

    const xml = state.xmlsFiltered.find(item => String(item.chave_nf || '').trim() === chave)

    if (!xml) {
      dispatch(showMessageBox(null, 'Nota Fiscal não encontrada'))
      setState(prevState => ({ ...prevState, beepNf: '' }))
      return
    }

    const xmls = state.xmls.map(item => (item.id === xml.id ? { ...item, selected: true } : item))
    const xmlsFiltered = state.xmlsFiltered.map(item =>
      item.id === xml.id ? { ...item, selected: true } : item,
    )
    const selecionarTodos = xmlsFiltered.length > 0 && xmlsFiltered.every(item => item.selected)

    setState(prevState => ({
      ...prevState,
      xmls,
      xmlsFiltered,
      selecionarTodos,
      beepNf: '',
    }))
  }

  const onSelecionarTodos = () => {
    const xmls = state.xmlsFiltered.map(item => {
      item.selected = !state.selecionarTodos
      return item
    })
    setState(prevState => ({
      ...prevState,
      xmlsFiltered: xmls,
      selecionarTodos: !state.selecionarTodos,
    }))
  }

  const updateCards = () => {
    const xmlsSelecteds = state.xmlsFiltered.filter(xml => xml.selected)
    const qteDeliveries = new Set(xmlsSelecteds.map(xml => xml.nome_fantasia)).size
    const qteIdentifiers = xmlsSelecteds.length
    const qteSkus = xmlsSelecteds.reduce((acc, xml) => acc + xml.qte_volume, 0)
    const weight = xmlsSelecteds.reduce((acc, xml) => acc + xml.peso_bruto, 0)

    setState(prevState => ({
      ...prevState,
      result: { qteDeliveries, qteIdentifiers, qteSkus, weight },
    }))
  }

  useEffect(() => {
    if (state.showMode !== ShowMode.CARDS) updateCards()
  }, [state.xmlsFiltered])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.IMPORTING:
        dispatch(showLoadingBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  const onDownloadXml = () => {
    window.open(urlDownloadXmls(selectedTp, ciclo.id, state.pInicial, state.pFinal), '_blank')
  }
  // Render
  return (
    <>
      <div className="p-grid">
        <div className="p-col-12">
          <SectionTitle title="Associar XMLs" />
        </div>
        {state.showMode === ShowMode.MESSAGE && (
          <>
            <div className="p-col-4">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={(pInicial, pFinal) => {
                  setState(prevState => ({
                    ...prevState,
                    pInicial,
                    pFinal,
                    result: { ...INITIAL_STATE.result },
                  }))
                  fetchEntregas(pInicial, pFinal)
                }}
              />
              <p style={{ fontSize: 12, color: 'gray' }}>
                *Período referente a data de emissão da nota
              </p>
            </div>
            <div className="p-col-1" style={{ marginTop: 27 }}>
              <Btn onClick={() => onDownloadXml()}>Download XMLs</Btn>
            </div>
            <div className="p-col-2">
              <CustomMultiSelect
                marginTop={10}
                optionLabel="name"
                options={state.ufs}
                value={state.selectedUfs}
                label="Estados"
                filter={true}
                onChange={uf => setState(prevState => ({ ...prevState, selectedUfs: uf }))}
              />
            </div>
            <div className="p-col-2">
              <CustomMultiSelect
                marginTop={10}
                optionLabel="name"
                label="Cidades"
                options={state.citiesOptions}
                value={state.selectedCities}
                onChange={cities =>
                  setState(prevState => ({ ...prevState, selectedCities: cities }))
                }
              />
            </div>
            <div className="p-col-2">
              <CustomMultiSelect
                marginTop={10}
                optionLabel="name"
                label="Bairros"
                options={state.bairrosOptions}
                value={state.selectedBairros}
                onChange={bairros =>
                  setState(prevState => ({ ...prevState, selectedBairros: bairros }))
                }
              />
            </div>
            <div className="p-col-2">
              <CustomMultiSelect
                marginTop={10}
                optionLabel="name"
                label="Info. Complementar"
                options={state.infoComplementarOptions}
                value={state.selectedInfoComplementar}
                onChange={info => setState(prev => ({ ...prev, selectedInfoComplementar: info }))}
              />
            </div>
            <div className="p-col-4" style={{ minWidth: 200 }}>
              <InputText
                marginTop={10}
                label="Beep NF"
                value={state.beepNf}
                onChange={value =>
                  setState(prevState => ({
                    ...prevState,
                    beepNf: value,
                  }))
                }
                onEnter={onBeepNfEnter}
              />
            </div>

            <div
              className="p-col-4"
              style={{ display: 'flex', alignItems: 'center', gap: 10, paddingTop: 35 }}
            >
              <div>
                <CustomCheckbox
                  checked={state.selecionarTodos}
                  onChange={() => onSelecionarTodos()}
                >
                  Selecionar Todos
                </CustomCheckbox>
              </div>
              <Btn
                onClick={onAssociarXmls}
                disabled={state.xmlsFiltered.findIndex(xml => xml.selected) === -1}
              >
                Associar Xmls
              </Btn>
            </div>
            <div className="p-col-12">
              <CardsResultadoImportacao
                weight={state.result.weight}
                qteSkus={state.result.qteSkus}
                qteIdentifiers={state.result.qteIdentifiers}
                qteDeliveries={state.result.qteDeliveries}
              />
            </div>

            <div className="p-col-12">
              <DataTable
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
                value={state.xmlsFiltered}
                emptyMessage="Não existe XMLs para associar a essa empresa"
                rows={10}
                paginator
              >
                <Column
                  header="#"
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={value => onCheckBoxClicked(item, value)}
                    />
                  )}
                  style={tableCellCentered(80)}
                />
                <Column sortable field="nNF" header="Nota Fiscal" style={tableCellCentered(200)} />
                <Column field="nome_fantasia" header="Cliente" />
                <Column field="logradouro" header="Logradouro" />
                <Column field="bairro" header="Bairro" />
                <Column field="city_name" header="Cidade" />
                <Column field="uf" header="UF" style={tableCellCentered()} />
                <Column field="qte_volume" header="Qte Sku" style={tableCellCentered()} />
                <Column field="peso_bruto" header="Peso" style={tableCellCentered()} />
                <Column
                  field="data_emissao"
                  header="Data Emissão"
                  style={tableCellCentered()}
                  body={item => formatIsoDateToLocale(item.data_emissao).toFormat('dd/MM/yyyy')}
                />
                <Column field="info_complementar" header="Info. Complementar" />
              </DataTable>
            </div>
          </>
        )}
        {state.showMode === ShowMode.CARDS && (
          <div className="p-col-12">
            <CardsResultadoImportacao
              weight={state.result.weight}
              qteSkus={state.result.qteSkus}
              qteIdentifiers={state.result.qteIdentifiers}
              qteDeliveries={state.result.qteDeliveries}
            />
          </div>
        )}
        {state.showMode === ShowMode.TABS && (
          <TabsClientesEhProdutosNaoCadastrados
            companyId={ciclo.company_id}
            produtosSemCadastros={state.produtosSemCadastros}
            clientesSemCadastros={state.clientesSemCadastros}
            produtosComInconsistencia={state.produtosComInconsistencia}
          />
        )}
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AssociarXmls))
